export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/word.2b6c827.svg";